import { render, staticRenderFns } from "./AddStock.vue?vue&type=template&id=f23dcdfc&scoped=true"
import script from "./AddStock.vue?vue&type=script&lang=js"
export * from "./AddStock.vue?vue&type=script&lang=js"
import style0 from "./AddStock.vue?vue&type=style&index=0&id=f23dcdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23dcdfc",
  null
  
)

export default component.exports